/**
 * 国家数据配置 - 按洲分组
 * 支持127个国家/地区
 */

export interface CountryInfo {
    code: string;
    name: string;
    nameEn: string;
    flag: string;
}

export interface ContinentGroup {
    id: string;
    name: string;
    nameEn: string;
    icon: string;
    countries: CountryInfo[];
}

// 亚洲国家 (31)
const asiaCountries: CountryInfo[] = [
    { code: 'CN', name: '中国大陆', nameEn: 'China', flag: '🇨🇳' },
    { code: 'HK', name: '中国香港', nameEn: 'Hong Kong', flag: '🇭🇰' },
    { code: 'TW', name: '中国台湾', nameEn: 'Taiwan', flag: '🇹🇼' },
    { code: 'MO', name: '中国澳门', nameEn: 'Macau', flag: '🇲🇴' },
    { code: 'JP', name: '日本', nameEn: 'Japan', flag: '🇯🇵' },
    { code: 'KR', name: '韩国', nameEn: 'South Korea', flag: '🇰🇷' },
    { code: 'SG', name: '新加坡', nameEn: 'Singapore', flag: '🇸🇬' },
    { code: 'MY', name: '马来西亚', nameEn: 'Malaysia', flag: '🇲🇾' },
    { code: 'TH', name: '泰国', nameEn: 'Thailand', flag: '🇹🇭' },
    { code: 'VN', name: '越南', nameEn: 'Vietnam', flag: '🇻🇳' },
    { code: 'ID', name: '印度尼西亚', nameEn: 'Indonesia', flag: '🇮🇩' },
    { code: 'PH', name: '菲律宾', nameEn: 'Philippines', flag: '🇵🇭' },
    { code: 'IN', name: '印度', nameEn: 'India', flag: '🇮🇳' },
    { code: 'PK', name: '巴基斯坦', nameEn: 'Pakistan', flag: '🇵🇰' },
    { code: 'BD', name: '孟加拉国', nameEn: 'Bangladesh', flag: '🇧🇩' },
    { code: 'LK', name: '斯里兰卡', nameEn: 'Sri Lanka', flag: '🇱🇰' },
    { code: 'NP', name: '尼泊尔', nameEn: 'Nepal', flag: '🇳🇵' },
    { code: 'MM', name: '缅甸', nameEn: 'Myanmar', flag: '🇲🇲' },
    { code: 'KH', name: '柬埔寨', nameEn: 'Cambodia', flag: '🇰🇭' },
    { code: 'LA', name: '老挝', nameEn: 'Laos', flag: '🇱🇦' },
    { code: 'BN', name: '文莱', nameEn: 'Brunei', flag: '🇧🇳' },
    { code: 'MN', name: '蒙古', nameEn: 'Mongolia', flag: '🇲🇳' },
    { code: 'KZ', name: '哈萨克斯坦', nameEn: 'Kazakhstan', flag: '🇰🇿' },
    { code: 'UZ', name: '乌兹别克斯坦', nameEn: 'Uzbekistan', flag: '🇺🇿' },
    { code: 'KG', name: '吉尔吉斯斯坦', nameEn: 'Kyrgyzstan', flag: '🇰🇬' },
    { code: 'TJ', name: '塔吉克斯坦', nameEn: 'Tajikistan', flag: '🇹🇯' },
    { code: 'TM', name: '土库曼斯坦', nameEn: 'Turkmenistan', flag: '🇹🇲' },
    { code: 'GE', name: '格鲁吉亚', nameEn: 'Georgia', flag: '🇬🇪' },
    { code: 'AM', name: '亚美尼亚', nameEn: 'Armenia', flag: '🇦🇲' },
    { code: 'AZ', name: '阿塞拜疆', nameEn: 'Azerbaijan', flag: '🇦🇿' },
];

// 欧洲国家 (37)
const europeCountries: CountryInfo[] = [
    { code: 'GB', name: '英国', nameEn: 'United Kingdom', flag: '🇬🇧' },
    { code: 'DE', name: '德国', nameEn: 'Germany', flag: '🇩🇪' },
    { code: 'FR', name: '法国', nameEn: 'France', flag: '🇫🇷' },
    { code: 'IT', name: '意大利', nameEn: 'Italy', flag: '🇮🇹' },
    { code: 'ES', name: '西班牙', nameEn: 'Spain', flag: '🇪🇸' },
    { code: 'PT', name: '葡萄牙', nameEn: 'Portugal', flag: '🇵🇹' },
    { code: 'NL', name: '荷兰', nameEn: 'Netherlands', flag: '🇳🇱' },
    { code: 'BE', name: '比利时', nameEn: 'Belgium', flag: '🇧🇪' },
    { code: 'AT', name: '奥地利', nameEn: 'Austria', flag: '🇦🇹' },
    { code: 'CH', name: '瑞士', nameEn: 'Switzerland', flag: '🇨🇭' },
    { code: 'PL', name: '波兰', nameEn: 'Poland', flag: '🇵🇱' },
    { code: 'CZ', name: '捷克', nameEn: 'Czech Republic', flag: '🇨🇿' },
    { code: 'SK', name: '斯洛伐克', nameEn: 'Slovakia', flag: '🇸🇰' },
    { code: 'HU', name: '匈牙利', nameEn: 'Hungary', flag: '🇭🇺' },
    { code: 'RO', name: '罗马尼亚', nameEn: 'Romania', flag: '🇷🇴' },
    { code: 'BG', name: '保加利亚', nameEn: 'Bulgaria', flag: '🇧🇬' },
    { code: 'GR', name: '希腊', nameEn: 'Greece', flag: '🇬🇷' },
    { code: 'SE', name: '瑞典', nameEn: 'Sweden', flag: '🇸🇪' },
    { code: 'NO', name: '挪威', nameEn: 'Norway', flag: '🇳🇴' },
    { code: 'DK', name: '丹麦', nameEn: 'Denmark', flag: '🇩🇰' },
    { code: 'FI', name: '芬兰', nameEn: 'Finland', flag: '🇫🇮' },
    { code: 'IE', name: '爱尔兰', nameEn: 'Ireland', flag: '🇮🇪' },
    { code: 'LT', name: '立陶宛', nameEn: 'Lithuania', flag: '🇱🇹' },
    { code: 'LV', name: '拉脱维亚', nameEn: 'Latvia', flag: '🇱🇻' },
    { code: 'EE', name: '爱沙尼亚', nameEn: 'Estonia', flag: '🇪🇪' },
    { code: 'HR', name: '克罗地亚', nameEn: 'Croatia', flag: '🇭🇷' },
    { code: 'SI', name: '斯洛文尼亚', nameEn: 'Slovenia', flag: '🇸🇮' },
    { code: 'RS', name: '塞尔维亚', nameEn: 'Serbia', flag: '🇷🇸' },
    { code: 'UA', name: '乌克兰', nameEn: 'Ukraine', flag: '🇺🇦' },
    { code: 'RU', name: '俄罗斯', nameEn: 'Russia', flag: '🇷🇺' },
    { code: 'AL', name: '阿尔巴尼亚', nameEn: 'Albania', flag: '🇦🇱' },
    { code: 'IS', name: '冰岛', nameEn: 'Iceland', flag: '🇮🇸' },
    { code: 'LU', name: '卢森堡', nameEn: 'Luxembourg', flag: '🇱🇺' },
    { code: 'MT', name: '马耳他', nameEn: 'Malta', flag: '🇲🇹' },
    { code: 'CY', name: '塞浦路斯', nameEn: 'Cyprus', flag: '🇨🇾' },
    { code: 'EU', name: '欧盟', nameEn: 'European Union', flag: '🇪🇺' },
];

// 美洲国家 (19)
const americasCountries: CountryInfo[] = [
    { code: 'US', name: '美国', nameEn: 'United States', flag: '🇺🇸' },
    { code: 'CA', name: '加拿大', nameEn: 'Canada', flag: '🇨🇦' },
    { code: 'MX', name: '墨西哥', nameEn: 'Mexico', flag: '🇲🇽' },
    { code: 'BR', name: '巴西', nameEn: 'Brazil', flag: '🇧🇷' },
    { code: 'AR', name: '阿根廷', nameEn: 'Argentina', flag: '🇦🇷' },
    { code: 'CL', name: '智利', nameEn: 'Chile', flag: '🇨🇱' },
    { code: 'CO', name: '哥伦比亚', nameEn: 'Colombia', flag: '🇨🇴' },
    { code: 'PE', name: '秘鲁', nameEn: 'Peru', flag: '🇵🇪' },
    { code: 'VE', name: '委内瑞拉', nameEn: 'Venezuela', flag: '🇻🇪' },
    { code: 'EC', name: '厄瓜多尔', nameEn: 'Ecuador', flag: '🇪🇨' },
    { code: 'UY', name: '乌拉圭', nameEn: 'Uruguay', flag: '🇺🇾' },
    { code: 'CR', name: '哥斯达黎加', nameEn: 'Costa Rica', flag: '🇨🇷' },
    { code: 'PA', name: '巴拿马', nameEn: 'Panama', flag: '🇵🇦' },
    { code: 'JM', name: '牙买加', nameEn: 'Jamaica', flag: '🇯🇲' },
    { code: 'TT', name: '特立尼达和多巴哥', nameEn: 'Trinidad and Tobago', flag: '🇹🇹' },
    { code: 'BS', name: '巴哈马', nameEn: 'Bahamas', flag: '🇧🇸' },
    { code: 'BB', name: '巴巴多斯', nameEn: 'Barbados', flag: '🇧🇧' },
    { code: 'AG', name: '安提瓜和巴布达', nameEn: 'Antigua and Barbuda', flag: '🇦🇬' },
];

// 中东国家 (15)
const middleEastCountries: CountryInfo[] = [
    { code: 'AE', name: '阿联酋', nameEn: 'United Arab Emirates', flag: '🇦🇪' },
    { code: 'SA', name: '沙特阿拉伯', nameEn: 'Saudi Arabia', flag: '🇸🇦' },
    { code: 'IL', name: '以色列', nameEn: 'Israel', flag: '🇮🇱' },
    { code: 'TR', name: '土耳其', nameEn: 'Turkey', flag: '🇹🇷' },
    { code: 'IR', name: '伊朗', nameEn: 'Iran', flag: '🇮🇷' },
    { code: 'IQ', name: '伊拉克', nameEn: 'Iraq', flag: '🇮🇶' },
    { code: 'JO', name: '约旦', nameEn: 'Jordan', flag: '🇯🇴' },
    { code: 'LB', name: '黎巴嫩', nameEn: 'Lebanon', flag: '🇱🇧' },
    { code: 'SY', name: '叙利亚', nameEn: 'Syria', flag: '🇸🇾' },
    { code: 'YE', name: '也门', nameEn: 'Yemen', flag: '🇾🇪' },
    { code: 'QA', name: '卡塔尔', nameEn: 'Qatar', flag: '🇶🇦' },
    { code: 'KW', name: '科威特', nameEn: 'Kuwait', flag: '🇰🇼' },
    { code: 'BH', name: '巴林', nameEn: 'Bahrain', flag: '🇧🇭' },
    { code: 'OM', name: '阿曼', nameEn: 'Oman', flag: '🇴🇲' },
];

// 非洲国家 (16)
const africaCountries: CountryInfo[] = [
    { code: 'ZA', name: '南非', nameEn: 'South Africa', flag: '🇿🇦' },
    { code: 'EG', name: '埃及', nameEn: 'Egypt', flag: '🇪🇬' },
    { code: 'NG', name: '尼日利亚', nameEn: 'Nigeria', flag: '🇳🇬' },
    { code: 'KE', name: '肯尼亚', nameEn: 'Kenya', flag: '🇰🇪' },
    { code: 'GH', name: '加纳', nameEn: 'Ghana', flag: '🇬🇭' },
    { code: 'MA', name: '摩洛哥', nameEn: 'Morocco', flag: '🇲🇦' },
    { code: 'DZ', name: '阿尔及利亚', nameEn: 'Algeria', flag: '🇩🇿' },
    { code: 'TN', name: '突尼斯', nameEn: 'Tunisia', flag: '🇹🇳' },
    { code: 'ET', name: '埃塞俄比亚', nameEn: 'Ethiopia', flag: '🇪🇹' },
    { code: 'TZ', name: '坦桑尼亚', nameEn: 'Tanzania', flag: '🇹🇿' },
    { code: 'UG', name: '乌干达', nameEn: 'Uganda', flag: '🇺🇬' },
    { code: 'RW', name: '卢旺达', nameEn: 'Rwanda', flag: '🇷🇼' },
    { code: 'ZM', name: '赞比亚', nameEn: 'Zambia', flag: '🇿🇲' },
    { code: 'ZW', name: '津巴布韦', nameEn: 'Zimbabwe', flag: '🇿🇼' },
    { code: 'BW', name: '博茨瓦纳', nameEn: 'Botswana', flag: '🇧🇼' },
];

// 大洋洲国家 (9)
const oceaniaCountries: CountryInfo[] = [
    { code: 'AU', name: '澳大利亚', nameEn: 'Australia', flag: '🇦🇺' },
    { code: 'NZ', name: '新西兰', nameEn: 'New Zealand', flag: '🇳🇿' },
    { code: 'FJ', name: '斐济', nameEn: 'Fiji', flag: '🇫🇯' },
    { code: 'PG', name: '巴布亚新几内亚', nameEn: 'Papua New Guinea', flag: '🇵🇬' },
    { code: 'SB', name: '所罗门群岛', nameEn: 'Solomon Islands', flag: '🇸🇧' },
    { code: 'VU', name: '瓦努阿图', nameEn: 'Vanuatu', flag: '🇻🇺' },
    { code: 'WS', name: '萨摩亚', nameEn: 'Samoa', flag: '🇼🇸' },
    { code: 'TO', name: '汤加', nameEn: 'Tonga', flag: '🇹🇴' },
];

// 按洲分组的完整数据
export const CONTINENT_GROUPS: ContinentGroup[] = [
    {
        id: 'asia',
        name: '亚洲',
        nameEn: 'Asia',
        icon: '🌏',
        countries: asiaCountries,
    },
    {
        id: 'europe',
        name: '欧洲',
        nameEn: 'Europe',
        icon: '🌍',
        countries: europeCountries,
    },
    {
        id: 'americas',
        name: '美洲',
        nameEn: 'Americas',
        icon: '🌎',
        countries: americasCountries,
    },
    {
        id: 'middle-east',
        name: '中东',
        nameEn: 'Middle East',
        icon: '🕌',
        countries: middleEastCountries,
    },
    {
        id: 'africa',
        name: '非洲',
        nameEn: 'Africa',
        icon: '🌍',
        countries: africaCountries,
    },
    {
        id: 'oceania',
        name: '大洋洲',
        nameEn: 'Oceania',
        icon: '🏝️',
        countries: oceaniaCountries,
    },
];

// 获取所有国家的扁平列表
export function getAllCountries(): CountryInfo[] {
    return CONTINENT_GROUPS.flatMap(group => group.countries);
}

// 根据国家代码查找国家信息
export function getCountryByCode(code: string): CountryInfo | undefined {
    return getAllCountries().find(c => c.code === code);
}

// 根据国家代码查找所属洲
export function getContinentByCountryCode(code: string): ContinentGroup | undefined {
    return CONTINENT_GROUPS.find(group =>
        group.countries.some(c => c.code === code)
    );
}

// 搜索国家（支持中文名、英文名、代码）
export function searchCountries(query: string): CountryInfo[] {
    const lowerQuery = query.toLowerCase();
    return getAllCountries().filter(country =>
        country.name.toLowerCase().includes(lowerQuery) ||
        country.nameEn.toLowerCase().includes(lowerQuery) ||
        country.code.toLowerCase().includes(lowerQuery)
    );
}
